import * as React from "react";
import { DeviceData } from "../models/DeviceData";
import Modal from "react-bootstrap/Modal";

interface Props {
    closeModal: () => void;
    manualInputDeviceMenuX: number;
    manualInputDeviceMenuY: number;
    deleteManualInput: () => void;
}

const ManualInputDeviceMenuItems = (props: Props) => {

    const handleDelete = () => {
        props.deleteManualInput();
        props.closeModal()
    }

    return (
        <Modal
            show={true}
            size="sm"
            animation={false}
            onEscapeKeyDown={() => props.closeModal()}
            onHide={() => props.closeModal()}
        >
            <div className="device_menuItems" style={{ position: "fixed", display: 'block', top: `${props.manualInputDeviceMenuY}px`, left: `${props.manualInputDeviceMenuX}px` }}>
                <span id="device_delete" onClick={handleDelete}>Delete</span>
            </div>
        </Modal>
    );
}

export default ManualInputDeviceMenuItems;